<template>
  <div class="_main">
    <div class="_formDiv">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        inline
        label-width="auto"
        label-position="top"
        v-loading="pageLoading"
      >
        <div class="_formTop">
          <div class="_Left">
            <el-upload
              class="avatar-uploader"
              accept=".jpg,.png"
              action="#"
              :http-request="handleFileUploadSmallImg"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="ruleForm.headImage"
                :src="ruleForm.headImage"
                accept="image/jpeg,image/png"
                class="_avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!-- 直接判断.length == 0 f12会报错 -->
            <div class="_text" v-show="isEmpty(ruleForm.headImage)">
              <div>jpg/png/jpeg</div>
              <div>最大5M</div>
            </div>
          </div>
          <div class="_Right">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="人员姓名：" prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入人员姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别：" prop="sex">
                  <el-select v-model="ruleForm.sex" placeholder="请选择性别">
                    <el-option label="男" value="男"></el-option>
                    <el-option label="女" value="女"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="人员编号：" prop="number">
                  <el-input
                    v-model="ruleForm.number"
                    placeholder="请输入人员编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系电话：" prop="phone">
                  <el-input
                    v-model="ruleForm.phone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="公司邮箱：" prop="email">
                  <el-input
                    v-model="ruleForm.email"
                    placeholder="请输入邮箱"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="岗位种类：" prop="jobType">
                  <el-select
                    v-model="ruleForm.jobType"
                    placeholder="请选择岗位种类"
                  >
                    <el-option
                      v-for="item in jobTypeData"
                      :key="item.dictValue"
                      :label="item.dictName"
                      :value="item.dictValue"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="聘用方式：" prop="employType">
                  <el-select
                    v-model="ruleForm.employType"
                    placeholder="请选择聘用方式"
                  >
                    <el-option
                      v-for="item in employTypeData"
                      :key="item.dictValue"
                      :label="item.dictName"
                      :value="item.dictValue"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="岗位状态：" prop="jobStatus">
                  <el-select
                    v-model="ruleForm.jobStatus"
                    placeholder="请选择岗位状态"
                  >
                    <el-option label="在职" value="0" key="0"></el-option>
                    <el-option label="离职" value="1" key="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- :disable-branch-nodes="true"  父节点不能选中
                     :flat = "true" 选中所有子节点，父节点不默认选中 -->
            <el-row :gutter="24">
              <el-col :span="12" style="padding-right: 60px">
                <el-form-item label="所在部门：" prop="deptInfoListCopy">
                  <treeselect
                    v-model="ruleForm.deptInfoListCopy"
                    :multiple="true"
                    :options="organizatonData"
                    :disable-branch-nodes="false"
                    :normalizer="normalizer"
                    :flat="true"
                    :placeholder="'请选择所在部门：'"
                    @select="deptChange()"
                  >
                    <template #option-label="{ node }">
                      <span class="_imgDiv">
                        <img
                          v-if="node.id == 1"
                          src="@/assets/pImg/szqy.png"
                          alt=""
                          class="_img"
                        />
                        <img
                          v-else
                          src="@/assets/pImg/dept.svg"
                          alt=""
                          class="_img"
                        />
                        {{ node.label }}
                      </span>
                    </template>
                  </treeselect>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="入职时间：" prop="joinDate">
                  <el-date-picker
                    v-model="ruleForm.joinDate"
                    type="date"
                    placeholder="选择日期"
                    :style="{ width: '100%' }"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学历：" prop="educationType">
                  <el-select
                    v-model="ruleForm.educationType"
                    placeholder="请选择学历"
                  >
                    <el-option
                      v-for="item in educationTypeData"
                      :key="item.dictValue"
                      :label="item.dictName"
                      :value="item.dictValue"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="_lineDiv">基础信息</div>
        <div class="_fromCenter">
          <el-row :gutter="24">
            <el-col :span="5">
              <el-form-item label="籍贯：" prop="jg">
                <el-input
                  v-model="ruleForm.jg"
                  placeholder="请输入籍贯"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="民族：" prop="mz">
                <el-input
                  v-model="ruleForm.mz"
                  placeholder="请输入民族"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="政治面貌：" prop="zzmmType">
                <el-select
                  v-model="ruleForm.zzmmType"
                  placeholder="请选择政治面貌"
                >
                  <el-option
                    v-for="item in zzmmTypeData"
                    :key="item.dictValue"
                    :label="item.dictName"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="户口地址：" prop="addressHj">
                <el-input
                  v-model="ruleForm.addressHj"
                  placeholder="请输入户口地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="现住址：" prop="address">
                <el-input
                  v-model="ruleForm.address"
                  placeholder="请输入现住址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="5">
              <el-form-item label="紧急联系人：" prop="contactName">
                <el-input
                  v-model="ruleForm.contactName"
                  placeholder="请输入紧急联系人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="紧急联系人电话：" prop="contactPhone">
                <el-input
                  v-model="ruleForm.contactPhone"
                  placeholder="请输入紧急联系人电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="身份证号：" prop="idCard">
                <el-input
                  v-model="ruleForm.idCard"
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="_lineDiv">驾驶证信息</div>
        <div class="_fromBottom">
          <div class="_photoDiv" @click="addPhoto()">
            <input
              type="file"
              ref="fileInput"
              @change="onFileChange"
              style="display: none"
              accept="image/jpeg,image/png"
            />
            <img v-if="showPhoto" :src="showPhoto" class="_avatar" />
            <i
              class="el-icon-plus avatar-uploader-icon"
              v-show="isEmpty(showPhoto)"
            ></i>
            <div class="_text2" v-show="isEmpty(showPhoto)">
              <div>jpg/png/jpeg</div>
              <div>最大5M</div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="_funcBottom">
      <el-button @click="backPreviousPage()" size="small">返回列表</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')" size="small"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  getOrganizationList,
  getDictList,
  queryStaffInfo,
  updateStaffInfo,
  addStaff,
} from '@/api/pServer/staff';
import CommonFile from '@/api/common';
export default {
  name: 'staffAdd',
  components: { Treeselect },
  props: ['staffId'],
  data() {
    // 自定义校验规则
    var validatePhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error('请输入有效的手机号'));
      } else {
        callback();
      }
    };
    var validatePhonesDifferent = (rule, value, callback) => {
      if (this.ruleForm.phone === this.ruleForm.contactPhone) {
        callback(new Error('手机号不能相同'));
      } else {
        callback();
      }
    };
    // 自定义验证身份证号的规则
    var checkIdCard = (rule, value, callback) => {
      const regIdCard =
        /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/;
      if (regIdCard.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的身份证号码'));
      }
    };
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_URL}${'/common/upload'}`,
      additionalData: {
        subDir: 'mars2024',
      },
      customHeader: {
        Token: 'mars',
        'Content-Type': 'multipart/form-data',
      },
      pageLoading: false,
      ruleForm: {
        id: '',
        name: '',
        sex: '',
        number: '',
        phone: '',
        email: '',
        jobType: '',
        jobTypeName: '',
        employType: '',
        employTypeName: '',
        jobStatus: '',
        joinDate: '',
        educationType: '',
        educationTypeName: '',
        imageUrl: '',
        jg: '',
        mz: '',
        zzmmType: '',
        zzmmTypeName: '',
        addressHj: '',
        address: '',
        contactName: '',
        contactPhone: '',
        idCard: '',
        headImage: '',
        deptInfoList: [],
        deptName: '',
        groupName: '',
        deptInfoListCopy: [],
        photoUrl: '',
      },

      showPhoto: '',
      normalizer(node) {
        return {
          children:
            node.childDeptDto && node.childDeptDto.length > 0
              ? node.childDeptDto
              : 0,
          label: node.name,
        };
      },
      deptChange() {
        this.$nextTick(() => {
          this.$refs['ruleForm'].validateField('deptInfoListCopy');
        });
      },
      organizatonData: [],
      jobTypeData: [],
      educationTypeData: [],
      employTypeData: [],
      zzmmTypeData: [],
      rules: {
        name: [
          { required: true, message: '请输入人员姓名', trigger: 'blur' },
          { min: 2, message: '长度在 2 个字符以上', trigger: 'blur' },
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        number: [
          { required: true, message: '请输入人员编号', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' },
        ],
        email: [{ required: true, message: '请输入电子邮箱', trigger: 'blur' }],
        jobType: [
          { required: true, message: '请选择岗位类型', trigger: 'change' },
        ],
        employType: [
          { required: true, message: '请选择聘用方式', trigger: 'change' },
        ],
        jobStatus: [
          { required: true, message: '请选择岗位状态', trigger: 'change' },
        ],
        deptInfoListCopy: [
          { required: true, message: '请选择部门', trigger: 'change' },
        ],
        joinDate: [
          { required: true, message: '请选择入职日期', trigger: 'change' },
        ],
        educationType: [
          { required: true, message: '请选择学历', trigger: 'change' },
        ],
        jg: [{ required: true, message: '请输入籍贯', trigger: 'blur' }],
        mz: [{ required: true, message: '请输入民族', trigger: 'blur' }],
        zzmmType: [
          { required: true, message: '请选择政治面貌', trigger: 'change' },
        ],
        addressHj: [
          { required: true, message: '请输入户口地址', trigger: 'blur' },
        ],
        address: [{ required: true, message: '请输入现住址', trigger: 'blur' }],
        contactName: [
          { required: true, message: '请输入紧急联系人姓名', trigger: 'blur' },
          { min: 2, message: '长度在 2 个字符以上', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入紧急联系人电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' },
          { validator: validatePhonesDifferent, trigger: 'blur' },
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: checkIdCard, trigger: 'blur' },
        ],
      },
      educationType: { dictCode: 'education_type' }, //教育程度
      employType: { dictCode: 'employ_type' }, //聘用方式
      jobType: { dictCode: 'job_type' }, //岗位类型
      zzmmType: { dictCode: 'zzmm_type' }, //政治面貌
    };
  },
  methods: {
    submitForm(formName) {
      // console.log('kkkk', this.ruleForm.joinDate);
      if (this.isEmpty(this.ruleForm.headImage)) {
        this.$message.error('请上传头像');
        return;
      }
      if (this.isEmpty(this.ruleForm.photoUrl)) {
        this.$message.error('请上传驾驶证照片');
        return;
      }
      this.$refs[formName].validate((valid) => {
        var deptList = [];
        this.ruleForm.deptInfoListCopy.forEach((data) => {
          deptList.push({ deptId: data });
        });
        this.ruleForm.deptInfoList = deptList;
        if (valid) {
          // console.log('入参:', this.ruleForm)
          if (this.$route.query.staffId) {
            //修改员工信息
            this.ruleForm.id = this.$route.query.staffId;
            this.updateStaffInfo(this.ruleForm);
          } else {
            //新增员工
            this.addStaff(this.ruleForm);
          }
        } else {
          return false;
        }
      });
    },
    isEmpty(str) {
      return !str || str.trim() === '';
    },
    isContainEmptyObject(obj) {
      for (var key in obj) {
        if (
          key != 'id' &&
          key != 'deptName' &&
          key != 'groupName' &&
          obj[key].length == 0
        ) {
          return true;
        }
      }
      return false;
    },
    backPreviousPage() {
      // this.$router.go(-1);
      window.history.back();
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG, PNG, JPEG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5M!');
        return false;
      }

      return isJPG && isLt2M;
    },
    handleFileUploadSmallImg(file) {
      this.pageLoading = true;
      CommonFile.commonUploadFile('zngy', file.file).then((res) => {
        this.pageLoading = false;
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.ruleForm.headImage = res.data.data.fileUrl;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    addPhoto() {
      this.$refs.fileInput.click();
    },
    //上传文件
    async onFileChange(event) {
      const selectedFiles = Array.from(event.target.files);
      CommonFile.commonUploadFile('zngy', selectedFiles[0])
        .then((res) => {
          if (res.data.code == 200) {
            this.ruleForm.photoUrl = res.data.data.filePath;
            this.showPhoto = res.data.data.fileUrl;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          event.target.value = '';
        });
    },
    // 获取组织结构
    async getOrganizationList() {
      const res = await getOrganizationList();
      this.organizatonData.push(res.data.data);
    },
    //聘用方式
    async getEmployType() {
      const res = await getDictList(this.employType);
      this.employTypeData = res.data.data;
    },
    //政治面貌
    async getZzmmType() {
      const res = await getDictList(this.zzmmType);
      this.zzmmTypeData = res.data.data;
    },
    //岗位种类
    async getJobType() {
      const res = await getDictList(this.jobType);
      this.jobTypeData = res.data.data;
    },
    //教育程度
    async getEducationType() {
      const res = await getDictList(this.educationType);
      this.educationTypeData = res.data.data;
    },
    //查询人员信息
    async queryStaffInfo(data) {
      const res = await queryStaffInfo(data);
      this.ruleForm = res.data.data;
      // console.log("ouyang",this.ruleForm)
      this.ruleForm.jobType = this.ruleForm.jobType.toString();
      this.ruleForm.employType = this.ruleForm.employType.toString();
      this.ruleForm.jobStatus = this.ruleForm.jobStatus.toString();
      this.ruleForm.educationType = this.ruleForm.educationType.toString();
      this.ruleForm.zzmmType = this.ruleForm.zzmmType.toString();
      this.showPhoto = this.ruleForm.photoUrl;
      var copy = [];
      this.ruleForm.deptInfoList.forEach((data) => {
        copy.push(data.deptId);
      });
      this.ruleForm.deptInfoListCopy = copy;
    },
    async updateStaffInfo(data) {
      this.pageLoading = true;
      const res = await updateStaffInfo(data);
      this.pageLoading = false;
      if (res.data.code == 200) {
        this.$message.success(res.data.message);
        this.$router.go(-1);
      } else {
        this.$message.error(res.data.message);
      }
    },
    async addStaff(data) {
      this.pageLoading = true;
      const res = await addStaff(data);
      if (res.data.code == 200) {
        this.$message.success(res.data.message);
        this.$router.go(-1);
      } else {
        this.$message.error(res.data.message);
      }
      this.pageLoading = false;
    },
  },
  created() {
    this.getOrganizationList();
    this.getEducationType();
    this.getEmployType();
    this.getJobType();
    this.getZzmmType();
    if (this.$route.query.staffId) {
      this.queryStaffInfo({ id: this.$route.query.staffId });
    }
  },
};
</script>
<style scoped>
._main {
  height: 100%;
  height: 100%;
  background-color: #fff;
}

._formDiv {
  height: calc(100% - 50px);
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}

._formTop {
  width: 100%;
  display: flex;
}

._Left {
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

._Right {
  flex: 1;
}

._imgDiv {
  height: 40px;
  display: flex;
  align-items: center;
}

._img {
  height: 20px;
  width: 20px;
  padding: 10px;
}

._lineDiv {
  height: 40px;
  line-height: 40px;
  width: 100%;
  border-bottom: 1px solid black;
  padding-left: 20px;
  /* font-family: 'Courier New', Courier, monospace; */
  font-weight: 700;
}

._fromCenter {
  padding-left: 20px;
}

._fromBottom {
  padding: 20px;
}

._photoDiv {
  height: 178px;
  width: 178px;
  border-style: dashed;
  border-width: 1px;
  /* 定义边框的宽度 */
  border-color: #cccccc;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

._funcBottom {
  padding: 10px;
  background-color: #f2f2f2;
  height: 50px;
  width: 100%;
  bottom: 5px;
  display: flex;
  align-items: center;
}

._text {
  position: absolute;
  top: 210px;
  font-size: 12px;
  color: #c0c4cc;
  /* display: flex; */
  text-align: center;
}

._text2 {
  position: absolute;
  top: 120px;
  font-size: 12px;
  color: #c0c4cc;
  text-align: center;
}

.el-date-editor {
  padding-right: 5px;
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

._avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* .el-icon-plus:before {
    line-height: 6
} */
</style>
